var _excluded = ["label"];
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { isValidElement, useCallback } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { notification, Tooltip } from 'antd';
import { getClassNames, simpleNotification } from '../../utils';
import { InfoCircleOutlined } from '@ant-design/icons';
function isInfoConfig(config) {
  return _typeof(config) === 'object' && config !== null && Object.keys(config).some(function (key) {
    return ['icon', 'title', 'inline'].includes(key);
  });
}
function isCopyConfig(config) {
  return _typeof(config) === 'object' && config !== null && Object.keys(config).some(function (key) {
    return ['value', 'onCopied'].includes(key);
  });
}
export var FormLayoutRow = function FormLayoutRow(_ref) {
  var _props$onCopied;
  var label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  /**
   * copy-to-clipboard settings
   */
  var copyValue = typeof props.value === 'string' ? props.value : undefined;
  var copyEnabled = !!copyValue && (props.copyEnabled || false);
  var onCopied = (_props$onCopied = props.onCopied) !== null && _props$onCopied !== void 0 ? _props$onCopied : useCallback(function (_, result) {
    notification.destroy();
    if (result) {
      simpleNotification('success', "Your ".concat([label], " has been copied!"));
    }
  }, [label]);
  if (isCopyConfig(props.copy)) {
    var _props$copy$value, _props$copy$onCopied;
    copyValue = (_props$copy$value = props.copy.value) !== null && _props$copy$value !== void 0 ? _props$copy$value : copyValue;
    copyEnabled = !!copyValue;
    onCopied = (_props$copy$onCopied = props.copy.onCopied) !== null && _props$copy$onCopied !== void 0 ? _props$copy$onCopied : onCopied;
  }

  // Allows pass-through of CopyToClipboard settings even when disabled
  var ValueWrapper = copyEnabled ? CopyToClipboard : function (_) {
    return _.children;
  };

  /**
   * info/tooltip settings
   */
  var infoValue = isValidElement(props.info) ? props.info : undefined;
  var infoInlined = false;
  var infoTooltipClassName;
  var infoIcon = isValidElement(props.infoIcon) ? props.infoIcon : /*#__PURE__*/React.createElement(InfoCircleOutlined, {
    className: "info-icon"
  });
  if (isInfoConfig(props.info)) {
    var _props$info$inline;
    infoIcon = isValidElement(props.info.icon) ? props.info.icon : infoIcon;
    infoValue = isValidElement(props.info.title) ? props.info.title : infoValue;
    infoTooltipClassName = props.info.tooltipClassName;
    infoInlined = (_props$info$inline = props.info.inline) !== null && _props$info$inline !== void 0 ? _props$info$inline : infoInlined;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row', props.className)
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-label')
  }, /*#__PURE__*/React.createElement("span", null, label), infoInlined && !!infoValue && /*#__PURE__*/React.createElement(Tooltip, {
    title: infoValue,
    overlayClassName: getClassNames('form-layout-row-tooltip', infoTooltipClassName)
  }, infoIcon)), props.value && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-value', _defineProperty({}, 'can-copy', copyEnabled))
  }, /*#__PURE__*/React.createElement(ValueWrapper, {
    onCopy: onCopied,
    text: copyValue
  }, /*#__PURE__*/React.createElement("span", null, props.value))), !infoInlined && infoValue && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-sub')
  }, infoIcon, /*#__PURE__*/React.createElement("span", null, infoValue)));
};